export default __webpack_public_path__ + "static/media/photo--lg--kara14.a9174609.jpg";